import PubSub from "underpub-js";
import BackgroundImageCard from "../../../elements/BackgroundImageCard/BackgroundImageCard";

var ListingCardSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingCardSlider',
	};

	$.extend(true, this.options, options);

};

ListingCardSlider.prototype.init = function() {

	var self = this;

	// slider
	this.$cardSlider = this.options.$el.find(`.${self.options.baseClass}__cardSlider`);

	// after init, we need to initialize all background card elements that were added
	this.$cardSlider.on('init', function(slick) {
		self.initSlides();
	});

	this.$cardSlider.on('reInit', function(slick) {
		self.initSlides();
	});

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		swipeToSlide: true,
		infinite: true,
		variableWidth: true,

		responsive: [
		
			{
				breakpoint: 769,
				settings: {
					centerMode: true,
					centerPadding: '0px',
					variableWidth: false,
					slidesToShow: 1,
				}
			},

		],

	});

	this.options.$el.find(`.${self.options.baseClass}__previousSlide`).on('click', function() {
		self.$cardSlider.slick('slickPrev');
	});

	this.options.$el.find(`.${self.options.baseClass}__nextSlide`).on('click', function() {
		self.$cardSlider.slick('slickNext');
	});

	// need to reinit after screen size because slick redoes the DOM
	PubSub.subscribe('resized', function() {
	    self.initSlides();
	});

};

ListingCardSlider.prototype.initSlides = function() {

	var self = this;

	self.options.$el.find('.slick-slide .el-BackgroundImageCard').each(function() {

		var component = new BackgroundImageCard({
			$el: $(this)
		});

		component.init();

	});

};

export default ListingCardSlider;
